import {Injectable} from "@angular/core";
import {Observable, Subject, Subscriber} from "rxjs";
import {forceUploadVerificationModalActions} from "./const";

@Injectable()
export class ForceUploadVerificationModalService {
  private warningPopupResultSubscriber$: Subscriber<void> = null;
  private readonly _open$: Subject<string> = new Subject<string>();
  private readonly _close$: Subject<void> = new Subject<void>();

  get open$(): Observable<string> {
    return this._open$.asObservable();
  }

  get close$(): Observable<void> {
    return this._close$.asObservable();
  }

  verify(action: forceUploadVerificationModalActions): void {
    this.closeModal();

    switch (action) {
      case forceUploadVerificationModalActions.Yes:
        this.warningPopupResultSubscriber$.next();
        this.warningPopupResultSubscriber$.complete();
        break;

      case forceUploadVerificationModalActions.No:
        this.warningPopupResultSubscriber$.error(undefined);
        break;
    }

    this.warningPopupResultSubscriber$ = null;
  }

  checkWarning(filename: string): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.warningPopupResultSubscriber$ = subscriber;

      this.openWarningDialog(filename);
    });
  }

  closeModal(): void {
    this._close$.next();
  }

  private openWarningDialog(filename: string): void {
    this._open$.next(filename);
  }
}
